import SelectHandPanel from "./SelectHandPanel";

export default SelectHandPanel;